const defaultState = {
    geojson: {
        type: "FeatureCollection", 
        features: []
    },
    manuscripts: {},
    genealogy: {}
}

function unflatten(arr) {
    var tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for(var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem["Ръкопис"]] = arrElem;
      mappedArr[arrElem["Ръкопис"]]['transcripts'] = [];
    }
    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        if (mappedElem["Извод"] && mappedArr[mappedElem['Извод']]) {
          mappedArr[mappedElem['Извод']]['transcripts'].push(mappedElem);
        } else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }

const convertToGeoJSON = input => {
    var output = {
        manuscripts: {},
        genealogy: [],
        geojson: {
            type: "FeatureCollection", 
            features: []
        }
    };
    var jurneys = {}
    input.forEach(item => {
        console.log(item);
        output.genealogy.push({
            'Ръкопис': item['Ръкопис'],
            'Извод': item['Извод'] || 'unknown',
            'transcripts': []
        })
        
        if(
            item.Longitude === undefined || 
            item.Latitude === undefined || 
            item.Longitude === '' || 
            item.Latitude === ''
        ) {
            return;
        }
        var feature = {
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [
                parseFloat(item.Longitude.split(',').join('.')), 
                parseFloat(item.Latitude.split(',').join('.'))
            ],
          },
          "properties": {
              id: output.geojson.features.length,
              manuscript: item["Ръкопис"],
              notes: item['Забележка'],
              locationName: item["Име на местоположението"],
              locationType: item["Тип на местоположението:"],
              authenticName: item["Възрожденско име на местоположението"],
              authencity: item["Автентично / Вероятно"],
              presentLocationName: item["Съвременно име на местоположението"]
          }
        }
        output.manuscripts[item["Ръкопис"]] = {...item};
        delete output.manuscripts[item["Ръкопис"]]["Име на местоположението"];
        delete output.manuscripts[item["Ръкопис"]]["Съвременно име на местоположението"];
        delete output.manuscripts[item["Ръкопис"]]["Тип на местоположението:"];
        delete output.manuscripts[item["Ръкопис"]]["Автентично / Вероятно"];
        delete output.manuscripts[item["Ръкопис"]]["Страници:"];
        delete output.manuscripts[item["Ръкопис"]]["Latitude"];
        delete output.manuscripts[item["Ръкопис"]]["Longitude"];
        output.geojson.features.push(feature);
        jurneys[item["Ръкопис"]] = jurneys[item["Ръкопис"]] ? jurneys[item["Ръкопис"]] : {};
        jurneys[item["Ръкопис"]][item["Име на местоположението"]] = [
            parseFloat(item.Longitude.split(',').join('.')), 
            parseFloat(item.Latitude.split(',').join('.'))
        ]
    });
    Object.keys(jurneys).sort().forEach(jurney => {
        var feature = {
            "type": "Feature",
            "geometry": {
              "type": "LineString",
              "coordinates": [],
            },
            "properties": {
                id: output.geojson.features.length,
                manuscript: jurney
            }
          }
        Object.keys(jurneys[jurney]).sort().forEach(key => {
            feature.geometry.coordinates.push(jurneys[jurney][key])
        })
        output.geojson.features.push(feature)
    });
    output.genealogy = unflatten(output.genealogy)
    return output;
}


export default (state=defaultState, action) => {
    switch(action.type) {
        case "GOOGLE_SHEETS_SUCCESS" : return action.label === "Travels" ? convertToGeoJSON(action.payload) : state;
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/Travels/reducer.js